import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import messages from "../../../redux/messages";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Container,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  Tooltip,
  OverlayTrigger,
  Dropdown,
} from "react-bootstrap";

import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import toastr from "toastr";

//Tabla, Navbar y Sidebar
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";
import CustomNavbar from "../../../components/CustomNavbar";
import SidebarCapacitacion from "../../../components/capacitacionDesarrollo/SidebarCapacitacion";

//redux
import {
  getGoalPerYear,
  deleteGoalPerYear,
  editGoalPerYear,
  saveGoalPerYear,
} from "../../../redux/capacitacionDesarrollo/goalPerYear/actions";

const GoalPerYear = (props) => {
  const schema = Yup.object().shape({
    meta: Yup.number()
      .integer("El número no puede tener decimales.")
      .min(0, "**El valor minimo es 0.")
      .required("**Campo requerido"),
    anio: Yup.number()
      .integer("El número no puede tener decimales.")
      .min(2000, "**El valor minimo es 2000.")
      .required("**Campo requerido"),
  });

  const { loader, goalPerYear, goalPerYearFail, saveLoader, formError } =
    useSelector((store) => store.goalPerYear);

  const [show, setShow] = useState(true);
  const onShowSidebar = () => setShow(show ? false : true);
  const [showFormModal, setShowFormModal] = useState(false);
  //
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  //
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  //
  const [validated, setValidated] = useState(false);
  const [filter, setFilter] = useState("");
  const dispatch = useDispatch();

  const filters = [
    { id: "anio", desc: "Año" },
    { id: "meta", desc: "Meta" },
  ];

  const [tipoBusqueda, setTipoBusqueda] = useState(filters[0]);

  const pages = Math.ceil(goalPerYear ? goalPerYear.count / limit : 0);

  //Datos custom table
  const columns = [
    {
      Header: "Año",
      accessor: "anio",
      Filter: "",
    },
    {
      Header: "Meta",
      accessor: "meta",
      Filter: "",
      Cell: (value) => <div>{parseInt(value.row.original.meta)}</div>,
    },
    {
      Header: "Fecha de creación",
      accesor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="button-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];

  //methods
  const _getGoalPerYear = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getGoalPerYear({
        offset: offs,
        limit: lim,
        tipo_busqueda: tipoBusqueda.id,
        filter:
          tipoBusqueda.id === "fecha_creacion"
            ? filt !== ""
              ? !isNaN(filt)
                ? filt
                : `${filt.charAt(6)}${filt.charAt(7)}${filt.charAt(
                    8
                  )}${filt.charAt(9)}-${filt.charAt(3)}${filt.charAt(
                    4
                  )}-${filt.charAt(0)}${filt.charAt(1)}`
              : filt
            : filt,
      })
    );

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowFormModal(true);
    setValidated(false);
  };

  const onDelete = (id, data) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteGoalPerYear(id, data));
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getGoalPerYear(oOffset, limit, oSearch);
  };

  const onAdd = () => {
    setShowFormModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getGoalPerYear(oOffset, limit, e.target.filter.value);
  };

  const onSubmit = (req) => {
    if (!edit) {
      dispatch(saveGoalPerYear(req, setShowFormModal));
    } else {
      dispatch(editGoalPerYear(editItem.id, req, index, setShowFormModal));
    }
  };

  useEffect(() => {
    _getGoalPerYear();
  }, []);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarCapacitacion show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="text-black-50 m-0 text-uppercase">META POR AÑO</h5>
            <Form onSubmit={onSearch}>
              <Form.Row className="justify-content-sm-end align-items-center flex-wrap">
                <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    type="search"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill mr-1"
                      onClick={() => seeAll()}
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                    <OverlayTrigger
                      placement="auto"
                      overlay={
                        <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                      }
                    >
                      <Dropdown className="mx-1">
                        <Dropdown.Toggle
                          variant="light"
                          className="btn-sm font rounded-pill"
                        >
                          <i className="material-icons">filter_list</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filters.map((item) => (
                            <Dropdown.Item
                              onClick={() => setTipoBusqueda(item)}
                              key={item.id}
                            >
                              {item.desc}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </OverlayTrigger>
                  </ButtonGroup>
                </Col>
              </Form.Row>
            </Form>
          </div>
          {!!goalPerYearFail && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {goalPerYearFail}
            </Alert>
          )}
          {loader ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : goalPerYear != null && goalPerYear.data.length > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <CustomTable columns={columns} data={goalPerYear.data} />
                </Card.Body>
              </Card>
              <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={goalPerYear.count}
                pages={pages}
                pagFunc={_getGoalPerYear}
              />
            </>
          ) : (
            <>
              {!goalPerYearFail && (
                <Alert variant="info" className="mt-4 mb-1 mx-3">
                  Aún no hay registros, comience creando algunos.
                </Alert>
              )}
            </>
          )}
        </Container>
        {/*Modal editar*/}
        <Modal show={showFormModal} onHide={() => setShowFormModal(false)}>
          <Formik
            validationSchema={schema}
            onSubmit={onSubmit}
            initialValues={{
              meta: edit
                ? editItem.meta !== null
                  ? parseInt(editItem.meta)
                  : parseInt(0)
                : parseInt(0),
              anio: edit ? editItem.anio : 2000,
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              //setFieldValue,
              values,
              touched,
              //isValid,
              errors,
            }) => (
              <Form onSubmit={handleSubmit} noValidate validated={validated}>
                <Modal.Header closeButton>
                  <Modal.Title className="ft-modal-title">
                    {edit ? "Editar Meta" : "Crear Meta"}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {formError && typeof formError !== "object" ? (
                    <Alert variant="danger" className="mt-4 mb-2 mx-3">
                      {formError}
                    </Alert>
                  ) : null}
                  <Form.Group as={Col}>
                    <Form.Label column sm="12" md="12">
                      Meta
                    </Form.Label>
                    <Form.Control
                      id="meta"
                      name="meta"
                      isInvalid={touched.meta && errors.meta}
                      isValid={touched.meta && !errors.meta}
                      onBlur={handleBlur("meta")}
                      onChange={handleChange}
                      value={values.meta}
                      type="number"
                      className="rounded-pill"
                      min={0}
                      placeholder="0"
                    />
                    {touched.meta && !!errors.meta && (
                      <div className="px-2">
                        <small className="text-danger">{errors.meta}</small>
                      </div>
                    )}
                  </Form.Group>
                  <Form.Group as={Col}>
                    <Form.Label column sm="12" md="12">
                      Año
                    </Form.Label>
                    <Form.Control
                      id="anio"
                      name="anio"
                      isInvalid={touched.anio && errors.anio}
                      isValid={touched.anio && !errors.anio}
                      onBlur={handleBlur("anio")}
                      onChange={handleChange}
                      value={values.anio}
                      type="number"
                      className="rounded-pill"
                      min={2000}
                      placeholder="2000"
                    />
                    {touched.anio && !!errors.anio && (
                      <div className="px-2">
                        <small className="text-danger">{errors.anio}</small>
                      </div>
                    )}
                  </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    className="rounded-pill"
                    variant="secondary"
                    onClick={() => setShowFormModal(false)}
                  >
                    Cerrar
                  </Button>
                  <Button
                    className="rounded-pill"
                    disabled={saveLoader}
                    variant="primary"
                    type="submit"
                  >
                    {saveLoader && (
                      <Spinner
                        className="mr-2"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    )}
                    Guardar
                  </Button>
                </Modal.Footer>
              </Form>
            )}
          </Formik>
        </Modal>
        {/*Modal*/}
      </div>
    </>
  );
};

export default GoalPerYear;
